export default () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.69238 5.30664C10.7966 5.30688 11.6922 6.2024 11.6924 7.30664V13.167C11.6922 14.2712 10.7966 15.1668 9.69238 15.167H3.83203C2.72773 15.1668 1.83222 14.2713 1.83203 13.167V7.30664C1.83225 6.20237 2.72775 5.30682 3.83203 5.30664H9.69238ZM3.83203 6.64062C3.46413 6.6408 3.16624 6.93875 3.16602 7.30664V13.167C3.16621 13.5349 3.46411 13.8328 3.83203 13.833H9.69238C10.0603 13.8328 10.3582 13.5349 10.3584 13.167V7.30664C10.3582 6.93879 10.0602 6.64086 9.69238 6.64062H3.83203ZM13.166 1.83301C14.2703 1.83322 15.1658 2.72872 15.166 3.83301V9.69336C15.1658 10.7976 14.2703 11.6931 13.166 11.6934H13.0781C12.71 11.6934 12.4112 11.3945 12.4111 11.0264C12.4111 10.6582 12.7099 10.3594 13.0781 10.3594H13.166C13.5339 10.3592 13.8318 10.0612 13.832 9.69336V3.83301C13.8319 3.4651 13.5339 3.16721 13.166 3.16699H7.30566C6.93775 3.16719 6.63982 3.46509 6.63965 3.83301V3.9209C6.63965 4.28909 6.34085 4.58789 5.97266 4.58789C5.60449 4.58787 5.30566 4.28907 5.30566 3.9209V3.83301C5.30584 2.72871 6.20137 1.83321 7.30566 1.83301H13.166Z"
      fill="currentColor"
    />
  </svg>
);
